var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBundles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3256_43594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2151 8.17505L13.7151 5.07005C13.6473 5.03728 13.5729 5.02026 13.4976 5.02026C13.4223 5.02026 13.3479 5.03728 13.2801 5.07005L5.78012 8.69005C5.69503 8.73057 5.62313 8.79432 5.57271 8.87394C5.52228 8.95356 5.49539 9.04581 5.49512 9.14005V17.4151C5.49478 17.5126 5.523 17.6082 5.57631 17.6899C5.62962 17.7717 5.70568 17.836 5.79512 17.8751L12.2951 20.97C12.3629 21.0028 12.4373 21.0198 12.5126 21.0198C12.5879 21.0198 12.6623 21.0028 12.7301 20.97L20.2301 17.3501C20.3152 17.3095 20.3871 17.2458 20.4375 17.1662C20.488 17.0865 20.5149 16.9943 20.5151 16.9V8.62505C20.5135 8.52917 20.4844 8.43577 20.4312 8.35599C20.378 8.2762 20.303 8.21339 20.2151 8.17505ZM13.5001 6.07505L18.9651 8.68505L16.4401 9.90505L11.1051 7.23005L13.5001 6.07505ZM12.5001 11.82L7.00012 9.20505L9.95012 7.78005L15.3001 10.455L12.5001 11.82ZM13.0001 19.7201V12.68L19.5001 9.53505V16.585L13.0001 19.7201Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3256_43594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBundles);
export default __webpack_public_path__ + "static/media/bundles.1364612c56255e5fa040a375081af534.svg";
export { ForwardRef as ReactComponent };